import { Group, Intersection, Matrix4, Plane, Ray, Raycaster, Vector3 } from 'three';

import { LineSegment2D, Point2D, point2DDistanceTo, projectPointOnLineSegment } from '@paragon/geometry-library';

import {
  convertFromDesignToLayoutCoordinates,
  convertFromLayoutToDesignCoordinates,
} from '../../library/layout-geometry/coordinates';
import { getCameraClickRadius } from '../ThreeJsSceneActions';

const WORK_LINES_PLANE = new Plane(new Vector3(0, 1, 0));

const inverseMatrix = new Matrix4();
const threeRaySource = new Ray();
const threeRay = new Ray();
const mousePositionVector = new Vector3();
let mousePosition = new Point2D(0, 0);
const projectedPoint = { x: 0, y: 0 };

export function raycastWorkLine(this: Group, raycaster: Raycaster, intersects: Intersection[]) {
  const segmentGeometry = this.userData.raycastSegment as LineSegment2D;
  if (segmentGeometry == null) return;

  if (!raycaster.ray.equals(threeRaySource)) {
    threeRay.copy(raycaster.ray);
    threeRaySource.copy(raycaster.ray);

    inverseMatrix.copy(this.matrixWorld).invert();
    threeRay.applyMatrix4(inverseMatrix);

    threeRay.intersectPlane(WORK_LINES_PLANE, mousePositionVector);
    mousePosition = convertFromDesignToLayoutCoordinates(mousePositionVector).projectTo2D();
  }

  const segmentContainsProjectedPoint = projectPointOnLineSegment(mousePosition, segmentGeometry, projectedPoint);
  if (!segmentContainsProjectedPoint) return;

  const distance = point2DDistanceTo(projectedPoint, mousePosition);
  if (distance > getCameraClickRadius()) return;

  const intersectionVector = new Vector3(...convertFromLayoutToDesignCoordinates(projectedPoint).toArray());
  const threeDimensionalDistance = intersectionVector.distanceTo(threeRay.origin);

  intersects.push({
    object: this,
    point: intersectionVector,
    distance: threeDimensionalDistance,
  });
}
